<template>
    <client-page>

        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Fleece & Sherpa Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Fleece & Sherpa Line" file="fleece">
                단/장 섬유의 셰르파와 폴라 플리스, 밍크 플리스, 테리 플리스, 벨루어, 브러쉬드 니트 등. 합성, 혼방 섬유 셰르파와 플리스 원단에 풍부한 경험을 가지며, 특히 뛰어난 품질과 가격을 만나보실 수 있습니다.
            </sub-product>
        </sub-section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped>
</style>
